// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"36af27fd","147":"9fe9b391","156":"097d0179","438":"39bbd81a","706":"4ad214eb","726":"292c2e31"}[chunkId] + ".chunk.js";
};